import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { EstimateCreatedV1DataSchema } from "./estimate-review-shared";

const InsuranceRevisionElectiveEstimateCreatedDataSchema = z.discriminatedUnion("version", [
  EstimateCreatedV1DataSchema,
]);

export const InsuranceRevisionElectiveEstimateCreatedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSURANCE_REVISION_ELECTIVE_ESTIMATE_CREATED),
  data: InsuranceRevisionElectiveEstimateCreatedDataSchema,
});

export type InsuranceRevisionElectiveEstimateCreatedTaskAttempt = z.infer<
  typeof InsuranceRevisionElectiveEstimateCreatedTaskAttemptSchema
>;
